<template>
  <div class="section footer-padding">
    <h1 class="is-size-3 has-text-primary">{{jobTitle}}</h1>
    <hr dashed/>

    <div class="columns">
      <div class="column is-4" v-for="(jobImage, index) in edittedJob.images" :key="jobImage.id">
        <ImageUpload :label="`Image ${index + 1}`"
          @input="(f) => $set(jobImage, 'tempFile', f)" :isSaved="!jobImage.tempFile"
          :image="jobImage.tempFile || jobImage.file.file"
          accept="image/jpeg,image/png,image/jpg"
        />
        <a class="button is-danger is-inverted"
          @click="removeImage(index)"><b-icon icon="close"/>
          &nbsp;&nbsp;Remove
        </a>
      </div>
      <div class="column is-4" v-if="edittedJob.images.length < 3">
        <ImageUpload :label="`Image ${edittedJob.images.length + 1}`"
          accept="image/jpeg,image/png,image/jpeg"
          @input="f => addImage(f)" :isSaved="true"/>
      </div>
    </div>
    <b-field label="Short Description"
      :custom-class="dirty && errors.short_description ? 'has-text-danger': null"
      :message="dirty && errors.short_description ? 'This field is required': null">
      <b-input v-model="edittedJob.short_description" rows="3"
      maxlength="200" type="textarea" placeholder="Text that will show up in job lists"/>
    </b-field>
    <b-field label="Description"
      :custom-class="dirty && errors.description ? 'has-text-danger': null"
      :message="dirty && errors.description ? 'This field is required': null">
      <b-input v-model="edittedJob.description" rows="12"
      maxlength="2000" type="textarea" placeholder="Describe your job advertisement details"/>
    </b-field>

    <div class="columns">
      <div class="column">
        <b-field label="Position type" horizontal
          :custom-class="dirty && errors.employment_type ? 'has-text-danger': null"
          :message="dirty && errors.employment_type ? 'This field is required': null">
          <AutoComplete :initialValue="edittedJob.employment_type" :options="employmentPositions"
            @select="(v) => edittedJob.employment_type = v"/>
        </b-field>

        <b-field horizontal label="Job type"
          :custom-class="dirty && errors.type ? 'has-text-danger': null"
          :message="dirty && errors.type ? 'This field is required': null">
          <AutoComplete :options="['delivery', 'charter', 'permanent', 'temporary']"
            :initialValue="edittedJob.type"
            @select="(v) => edittedJob.type = v"/>
        </b-field>

        <b-field label="Country from" horizontal
          :custom-class="dirty && errors.country_from ? 'has-text-danger': null"
          :message="dirty && errors.country_from ? 'This field is required': null">
          <AutoComplete :initialValue="edittedJob.country_from" :options="countries"
            @select="(v) => edittedJob.country_from = v" />
        </b-field>

        <b-field label="Harbor from" horizontal
          :custom-class="dirty && errors.harbor_from ? 'has-text-danger': null"
          :message="dirty && errors.harbor_from ? 'This field is required': null">
          <b-input v-model="edittedJob.harbor_from" />
        </b-field>

        <b-field label="Country to" horizontal
          :custom-class="dirty && errors.country_to ? 'has-text-danger': null"
          :message="dirty && errors.country_to ? 'This field is required': null">
          <AutoComplete :initialValue="edittedJob.country_to" :options="countries"
            @select="(v) => edittedJob.country_to = v" />
        </b-field>

        <b-field label="Harbor to" horizontal
          :custom-class="dirty && errors.harbor_to ? 'has-text-danger': null"
          :message="dirty && errors.harbor_to ? 'This field is required': null">
          <b-input v-model="edittedJob.harbor_to" />
        </b-field>

        <b-field label="Start date" horizontal
          :custom-class="dirty && errors.from_date ? 'has-text-danger': null"
          :message="dirty && errors.from_date ? 'This field is required': null">
          <b-datepicker placeholder="Click to select..."
            :value="edittedJob.from_date && new Date(edittedJob.from_date)"
            @input="(d) => edittedJob.from_date = $moment(d).format('YYYY-MM-DD')"
            :focused-date="edittedJob.from_date ? new Date(edittedJob.from_date): new Date()"
            icon="calendar-today"/>
        </b-field>

        <b-field label="End date" horizontal>
          <b-datepicker placeholder="Leave empty for permanent..."
            :value="edittedJob.to_date && new Date(edittedJob.to_date)"
            @input="(d) => edittedJob.to_date = $moment(d).format('YYYY-MM-DD')"
            :focused-date="edittedJob.to_date ? new Date(edittedJob.to_date): new Date()"
            icon="calendar-today"/>
        </b-field>

        <b-field label="Payment (€)" horizontal>
          <b-input type="number"
            :value="edittedJob.salary"
            @input="(v) => edittedJob.salary = +v || null" />
        </b-field>

        <b-field label="Boat Ownership type" horizontal
          :custom-class="dirty && errors.vessel_ownership_type ? 'has-text-danger': null"
          :message="dirty && errors.vessel_ownership_type ? 'This field is required': null">
          <b-radio v-model="edittedJob.vessel_ownership_type"
            v-for="i in ownershipTypes"
            :key="i" :native-value="i" type="is-black">{{i}}</b-radio>
        </b-field>

        <b-field label="Boat type" horizontal
          :custom-class="dirty && errors.vessel_type ? 'has-text-danger': null"
          :message="dirty && errors.vessel_type ? 'This field is required': null">
          <b-radio v-model="edittedJob.vessel_type" v-for="i in ['Sailing boat', 'Speed boat']"
            :key="i" :native-value="i" type="is-black">{{i}}</b-radio>
        </b-field>

        <b-field label="Boat Sub type" horizontal v-if="edittedJob.vessel_type">
          <b-radio v-model="edittedJob.vessel_sub_type" v-for="i in subTypes"
            :key="i" :native-value="i" type="is-black">{{i}}</b-radio>
        </b-field>

        <b-field label="Vessel size (ft)" horizontal
          :custom-class="dirty && errors.vessel_size_ft ? 'has-text-danger': null"
          :message="dirty && errors.vessel_size_ft ? 'This field is required': null">
          <b-input type="number"
            :value="edittedJob.vessel_size_ft"
            @input="(v) => edittedJob.vessel_size_ft = +v || null" />
        </b-field>
      </div>

      <div class="column">
        <b-field horizontal v-for="[label, skills] in Object.entries(allSkills)"
          :label="label" :key="label"
          :custom-class="dirty && errors[label] ? 'has-text-danger': null"
          :message="dirty && errors[label] ? 'This field is required': null">
          <AutoCompleteMultiple :options="skills"
            :value="edittedJob.skills.filter(s => skillToCategory[s] === label)"
            @input="(v) => handleInput(label, v)"/>
        </b-field>
      </div>
    </div>
    <Footer>
      <a :class="[
        'button', 'is-medium',
        'is-primary', loading && 'is-loading']"
        :disabled="!hasChanges"
        @click="save">
        Save
      </a>
    </Footer>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { mapState, mapGetters } from 'vuex';
import AutoComplete from '@/components/AutoComplete';
import AutoCompleteMultiple from '@/components/AutoCompleteMultiple';
import Footer from '@/components/Footer';
import isEqual from 'lodash/isEqual';
import ImageUpload from '@/components/ImageUpload';
import Vue from 'vue';

export default {
  components: {
    AutoComplete,
    AutoCompleteMultiple,
    Footer,
    ImageUpload,
  },
  props: {
    job: {
      type: Object,
      default: () => ({
        description: '',
        short_description: '',
        employment_type: null,
        vessel_size_ft: null,
        type: null,
        skills: [],
        images: [],
        from_date: Vue.$moment().format('YYYY-MM-DD'),
        to_date: null,
        country_from: null,
        harbor_from: null,
        country_to: null,
        harbor_to: null,
        salary: null,
        vessel_type: null,
        vessel_ownership_type: null,
        vessel_sub_type: null,
      }),
    },
    onSave: Function,
  },
  data() {
    return {
      edittedJob: null,
      loading: false,
      dirty: false,
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      employmentPositions: state => state.content.employment_positions,
      countries: state => state.content.countries,
      allSkills: state => state.content.skills,
    }),
    ...mapGetters({
      skillToCategory: 'content/skillToCategory',
    }),
    hasChanges() {
      return !isEqual(this.job, this.edittedJob);
    },
    jobTitle() {
      if (!this.job.id) {
        return 'New Job';
      }
      return `Job Advertisement #${this.job.id} created at ${this.$moment(this.job.created).format('MMMM Do YYYY')}`;
    },
    ownershipTypes() {
      if (this.user.type === 'charterer') {
        return ['charter'];
      }
      return ['private', 'charter'];
    },
    subTypes() {
      const types = ['Catamaran', 'Monohull'];
      if (this.edittedJob.vessel_type === 'Sailing boat') return types;
      return types.concat(['RIB']);
    },
    errors() {
      let fields = [
        'description', 'short_description',
        'employment_type', 'type',
        'country_from', 'from_date',
        'vessel_ownership_type',
      ];

      if (['Engineer', 'Shipyard/Dock Services', 'Diver'].indexOf(this.edittedJob.employment_type) === -1) {
        fields = fields.concat(['harbor_from', 'country_to', 'harbor_to', 'vessel_size_ft', 'vessel_type']);
      }

      const errors = fields.reduce(
        (acc, field) => {
          acc[field] = Array.isArray(this.edittedJob[field])
            ? !this.edittedJob[field].length
            : !this.edittedJob[field];
          return acc;
        }, {},
      );
      errors.Languages = !this.edittedJob.skills.filter(s => this.skillToCategory[s] === 'Languages').length;
      return errors;
    },
  },
  methods: {
    handleInput(label, v) {
      this.edittedJob.skills = this.edittedJob.skills.filter(
        s => this.skillToCategory[s] !== label,
      ).concat(v);
    },
    async save() {
      this.dirty = true;
      if (Object.values(this.errors).some(v => v)) {
        this.$toast.open({
          message: 'There are missing required fields',
          type: 'is-danger',
        });
        return;
      }
      this.loading = true;
      const newImages = await Promise.all(this.edittedJob.images.map(async (i) => {
        if (!i.tempFile) {
          return Promise.resolve({ ...i, file: i.file.id });
        }
        const data = new FormData();
        data.append('category', 'job_image');
        data.append('file', i.tempFile);
        const newFile = (await this.$http.post('files/', data, { 'Content-Type': 'multipart/form-data' })).data;
        return Promise.resolve({ ...i, file: newFile.id, tempFile: undefined });
      }));
      await this.onSave({ ...this.edittedJob, images: newImages });
      this.initialize();
      this.loading = false;
    },
    addImage(f) {
      if (!f) {
        return;
      }
      this.edittedJob.images.push({
        order: this.edittedJob.images.length + 1,
        tempFile: f,
        job_id: this.job.id,
      });
    },
    removeImage(imageIndex) {
      this.edittedJob.images.splice(imageIndex, 1);
      this.edittedJob.images = this.edittedJob.images.map(
        (i, index) => ({ ...i, order: index + 1 }),
      );
    },
    initialize() {
      this.edittedJob = cloneDeep(this.job);
    },
  },
  created() {
    this.initialize();
  },
};
</script>


<style lang="scss" scoped>

/deep/ .field-label {
  flex-grow: 2
}

/deep/ .dropdown-menu {
  z-index: 1000
}
</style>
